export const parkwellStyles = {
	header: {
		backgroundColor: '#54aad7',
	},
	sidebar: {
		backgroundColor: '#193442',
		color: 'white',
	},
	button: {
		backgroundColor: '#eb5466',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#b03f4d',
		},
	},
	text: {
		color: '#193442',
		buttonLoadingColor: '#FFFFFF',
	},
	title: {
		color: '#fff',
	},
	table: {
		headerBackgroundColor: '#54aad7',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Parkwell Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/parkwell/parkwell-icon-white.svg',
			height: 40,
			width: 57,
		},
		large: {
			src: '/parkwell/parkwell-logo-vertical-white.svg',
			height: 65,
			width: 145,
		},
	},
	favicon: {
		src: '/parkwell/parkwell-icon-white.svg',
	},
	socials: {
		linkedIn: 'https://www.linkedin.com/company/parkwell/',
	},
	siteUrl: 'https://goparkwell.com/',
	orgName: 'Parkwell',
};
